import { entityModalTypes } from './entityModalTypes';


export const entityModalConfig = [
    {
        modalType: entityModalTypes.TRANSFER_SUCCESS_MODAL,
        modalId: 'bob-transfer-success-modal',
        modalHeaderTextData: 'bob.transfer.success'
    },
    {
        modalType: entityModalTypes.TRANSFER_PARTIAL_SUCCESS_MODAL,
        modalId: 'bob-transfer-partial-success-modal',
        modalHeaderTextData: 'bob.transfer.partial_success'
    },
    {
        modalType: entityModalTypes.TRANSFER_IN_PROGRESS_MODAL,
        modalId: 'bob-transfer-in-progress-modal',
        modalHeaderTextData: 'bob.transfer.in_progress'
    },
    {
        modalType: entityModalTypes.TRANSFER_INCOMPLETE_MODAL,
        modalId: 'bob-transfer-incomplete-modal',
        modalHeaderTextData: 'bob.transfer.incomplete'
    },
    {
        modalType: entityModalTypes.TRANSFER_FAILURE_MODAL,
        modalId: 'bob-trasnfer-failure-modal',
        modalHeaderTextData: 'bob.transfer.failure'
    },
    {
        modalType: entityModalTypes.TRANSFER_ERROR_MODAL,
        modalId: 'bob-transfer-error-modal',
        modalHeaderTextData : 'bob.transfer.error'
    },
    {
        modalType: entityModalTypes.TRANSFER_VALIDATION_ERROR_MODAL,
        modalId: 'bob-transfer-validation_error-modal',
        modalHeaderTextData : 'bob.transfer.validation_error'
    }
];
